import Vue from 'vue';
import { createActionHelpers } from 'vuex-loading';
import Service from './service';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_PROPOSAL = 'UPDATE_PROPOSAL';
export const UPDATE_CONDITIONS = 'UPDATE_CONDITIONS';
export const ADD_CONDITION = 'ADD_CONDITION';
export const UPDATE_SHOW_PDF = 'UPDATE_SHOW_PDF';
export const UPDATE_PDF_LINK = 'UPDATE_PDF_LINK';
export const DELETE_CONDITION = 'DELETE_CONDITION';
export const RESET_CONDITIONS = 'RESET_CONDITIONS';
export const clearModuleAction = 'clearModuleAction';
export const updateProposalAction = 'updateProposalAction';
export const initModuleAction = 'initModuleAction';
export const addConditionAction = 'addConditionAction';
export const updateShowPdfAction = 'updateShowPdfAction';
export const getPdfLinkAction = 'getPdfLinkAction';
export const deleteConditionAction = 'deleteConditionAction';
export const resetConditionsAction = 'resetConditionsAction';
export default {
  namespaced: true,
  state: {
    proposal: {},
    conditions: [],
    conditionsData: {},
    operation: null,
    showPdf: false,
    pdfLink: '',
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'proposal', {});
      Vue.set(state, 'conditions', []);
      Vue.set(state, 'conditionsData', {});
      Vue.set(state, 'operation', null);
      Vue.set(state, 'showPdf', false);
      Vue.set(state, 'pdfLink', '');
    },
    [UPDATE_PROPOSAL](state, payload) {
      Vue.set(state, 'proposal', payload);
    },
    [UPDATE_CONDITIONS](state, payload) {
      if (payload[0].condiciones) {
        const arr = payload[0].condiciones.split('&');
        arr.forEach((condition) => {
          state.conditions.push(condition);
        });
      }
    },
    [ADD_CONDITION](state) {
      state.conditions.push(' ');
    },
    [UPDATE_SHOW_PDF](state, payload) {
      state.showPdf = payload;
    },
    [UPDATE_PDF_LINK](state, payload) {
      Vue.set(state, 'pdfLink', payload);
    },
    [DELETE_CONDITION](state, payload) {
      state.conditions.splice(payload, 1);
    },
    [RESET_CONDITIONS](state) {
      state.conditions.splice(0, state.conditions.length);
    },
  },
  actions: {
    [clearModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [initModuleAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'propuesta');
      commit(CLEAR_MODULE);
      Service.getProposal(payload)
        .then((res) => {
          if (res.length) {
            commit(UPDATE_PROPOSAL, res[0]);
            commit(UPDATE_CONDITIONS, res);
          } else {
            commit(UPDATE_PROPOSAL, {});
            commit(UPDATE_CONDITIONS, [' ']);
          }
          endLoading(dispatch, 'propuesta');
        });
    },
    [getPdfLinkAction]({ commit, dispatch }, payload) {
      Service.getProposal(payload)
        .then((res) => {
          if (res.length && res[0].pdf) {
            Service.getPdfLink(res[0].pdf)
              .then((pdf) => {
                commit(UPDATE_PDF_LINK, pdf);
              });
          } else {
            commit(UPDATE_PDF_LINK, '');
          }
        });
    },
    [updateProposalAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'update propuesta');
      if (payload.model.id === 'dummy') {
        Service.createProposal(payload.model)
          .then(() => dispatch('initModuleAction', payload.model.operacion))
          .catch(error => dispatch('updateErrorOverlay', error, { root: true }));
      } else {
        Service.updateProposal(payload.model)
          .then(() => {
            endLoading(dispatch, 'update propuesta');
            dispatch('initModuleAction', payload.model.operacion);
          })
          .catch((error) => {
            endLoading(dispatch, 'update propuesta');
            dispatch('updateErrorOverlay', error, { root: true });
          });
      }
    },
    [addConditionAction]({ commit }, payload) {
      commit(ADD_CONDITION, payload);
    },
    [updateShowPdfAction]({ commit }, payload) {
      commit(UPDATE_SHOW_PDF, payload);
    },
    [deleteConditionAction]({ commit }, payload) {
      commit(DELETE_CONDITION, payload);
    },
    [resetConditionsAction]({ commit }) {
      commit(RESET_CONDITIONS);
    },
  },
  getters: {
    proposal: state => state.proposal,
    conditions: state => state.conditions,
    showPdf: state => state.showPdf,
    pdfLink: state => state.pdfLink,
  },
};



// WEBPACK FOOTER //
// ./src/features/propuesta-no-vinculante/store.js